import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, Skeleton, Typography } from '@mui/material';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { fetchUserInfo } = useAuth();

  useEffect(() => {
    const processAuth = async () => {
      await fetchUserInfo();
      navigate('/', { replace: true });
    };
    processAuth();
  }, [fetchUserInfo, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        gap: 2,
      }}
    >
      <Skeleton height="400px" width="80%" />
      <Typography variant="h6">Completando autenticación...</Typography>
    </Box>
  );
};

export default AuthCallback; 